module.exports = __webpack_public_path__ + "img/ABITO COSTARICA.aeac0b55.jpg";